module.exports = __webpack_public_path__ + "img/qrcode.9039892b.png";